import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 2,
		d: "M8.538 20.505l8.602-8.447-8.602-8.446",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})
});
export default SvgChevronRightinline;
